<div class="datepicker datepicker_full" [id]="id$"></div>
